import { endpointsList } from '@/helpers';
import axios from 'axios';
import { IKksValidationResultDto, IValidateKksListDto } from 'types';
import { removeEmptyStrings } from 'utils';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useToast } from './useToast';

export function useKksValidator() {
  const isValidatingKks = ref(false);
  const kksValidationList = ref<IKksValidationResultDto[]>([]);
  const { t } = useI18n();
  const { createErrorToast } = useToast();

  async function validateKks(
    kksList: string[],
    location: string,
  ): Promise<IKksValidationResultDto[] | undefined> {
    kksList = removeEmptyStrings(kksList);
    if (!kksList.length) return;

    const dto: IValidateKksListDto = { kksList, location };

    try {
      isValidatingKks.value = true;

      const response = await axios.post(
        endpointsList.prodisApiIntegration.validateKksList(),
        dto,
      );

      kksValidationList.value = response.data;
      return response.data;
    } catch {
      createErrorToast(t('kksValidator.errors.errorValidatingKks'));
    } finally {
      isValidatingKks.value = false;
    }
  }

  return {
    isValidatingKks,
    kksValidationList,
    validateKks,
  };
}
